module.exports = __webpack_public_path__ + "img/start0.2e54b78b.jpg";